import { render } from "./Select.vue?vue&type=template&id=48571ad5"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__